<template>
  <div>
    <div style="margin-bottom:20px;">
      <Input v-model="searchCont" placeholder="Enter something..." clearable style="width: 200px;" />
      <Button type="primary" size="default" @click="searchHandler" style=" margin-left :10px;">查询</Button>
    </div>
    <div class="demo-spin-container">
      <Table
        border
        ref="selection"
        :columns="columns12"
        :data="data6"
        @on-selection-change="changeSelection"
      >
        <template slot-scope="{ row }" slot="name">
          <strong>{{ row.name }}</strong>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <Button type="primary" size="small" style="margin-right: 5px" @click="show(row)">详情</Button>
          <!-- <Button type="error" size="small" @click="remove(index)">删除</Button> -->
        </template>
      </Table>
      <Spin size="large" fix v-if="spinShow"></Spin>
    </div>
    <Page
      class="pageBox"
      style="margin-top: 30px;text-align: center"
      :total="pageTotal"
      :current="page"
      :page-size="limit"
      @on-change="changePage"
    />
  </div>
</template>
<script>
import api from "@/api/api";
import globalBus from "../../globals/globalBus";
export default {
  data() {
    return {
      pageTotal: 10, // 数据总条数
      page: 1, // 页码
      limit: 10, // 每页显示条数
      searchCont: "",
      columns12: [
        {
          title: "编号",
          key: "id",
          align: "center",
        },
        {
          title: "设备名称",
          key: "channelName",
          align: "center"
        },
        {
          title: "设备类型",
          key: "deviceType",
          align: "center"
        },

        {
          title: "单位",
          key: "insUnit",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "center"
        }
      ],
      data6: [],
      spinShow: true,
      path:[]
    };
  },
  
  methods: {
    //编辑显示的页面
    show(row,index) {
      let path = [
        localStorage.getItem('clientId')
      ]
      localStorage.setItem('pat' , path)
      //
      this.$router.push({
        path: `/device_management/channel_properties/${row.deviceId}`
      });
    },
    // 复选框选中内容
    changeSelection(selection) {
      this.selectionId = [];
      selection.map(item => {
        this.selectionId.push(item.id);
      });
    },
    // 获取页面数据
    getData() {
      api.queryFormulaFIns({ formulaId: this.$route.params.id, limit : this.limit , page : this.page }).then(res => {
        let data = res.data;
       
        if (data.code === 0) {
            // this.data6 = data["page"]["list"];
            data["page"]["list"].map((item)=>{
              if(item.channel == null){
                  this.data6.push({
                  id : item.id,
                  deviceId : item.deviceId,
                  deviceType : item.deviceType == 0 ? "通道" : "传感器",
                  insUnit : item.insUnit,
                  formulaId : item.formulaId,
                  channelName : ""
                })
              }else{
                this.data6.push({
                  id : item.id,
                  deviceId : item.deviceId,
                  deviceType : item.deviceType == 0 ? "通道" : "传感器",
                  insUnit : item.insUnit,
                  formulaId : item.formulaId,
                  channelName : item.channel.chanName = null ? "" : item.channel.chanName
                })
              }
              
            })
            this.pageTotal = data["page"]["totalCount"];
            if(this.data6 == ""){
              this.spinShow = false
            }else{
              this.spinShow = false
            }
        } else {
          this.$Message.error(data.msg);
        }
      });
    },
    // 搜索
    searchHandler() {
      this.selectionId = [];
      this.page = 1;
      this.getData();
      this.isSearchMore = false;
    },
    changePage(val) {
      this.page = val;
    }
  },
  created() {
    this.getData();
  },
  watch: {
    page: {
      handler() {
        this.getData();
      },
      deep: true
    }
  }
};
</script>
<style scoped>
.demo-spin-container {
  display: inline-block; 
  width:100%;
  /* height: 100px; */
  position: relative;
  /* border: 1px solid #eee; */
}
</style>